// App.js
import { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import RoutesConfig from "./Route/Route";
import { Auth0Provider } from "@auth0/auth0-react";
import env from "./env";

const App = () => {
  return (
    <>
      <Auth0Provider
        domain={env.AUTH0_DOMAIN}
        clientId={env.AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: env.AUTH0_REDIRECT_URI,
          audience: env.API_AUDIENCE || undefined,
        }}
      >
        <Router>
          <Suspense fallback={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}><ThreeDots color="rgb(89, 89, 89)" height={80} width={80} /></div>}>
            <RoutesConfig />
          </Suspense>
        </Router>
      </Auth0Provider>
    </>
  );
};

export default App;
